import React, { memo, useMemo } from 'react';
import block from 'bem-cn';

import SlotsIcon, { ISlotsIconProps } from '../SlotsIcon/SlotsIcon';
import { AdditionalInfo,MainInfo } from './components';
import { PragmaticDGAGame } from './hooks';

import './PragmaticDGA.scss';

type PragmaticDGAProps = ISlotsIconProps & {
  gameInfo: PragmaticDGAGame,
}

const b = block('pragmatic-dga');

// TODO: сделать
// 1. baccarat
// 2. добавить dealer в играх
export const PragmaticDGA = memo(({ slot, gameInfo }: PragmaticDGAProps) => {
  const image = useMemo(() => (
    <div className={b()} style={{ backgroundImage: `url(${gameInfo.tableImage})` }}>
      <div className={b('main-info')}>
        <MainInfo {...gameInfo} />
      </div>
      <div className={b('additional-info')}>
        <AdditionalInfo gameInfo={gameInfo} />
      </div>
    </div>
  ), [gameInfo]);
  return (
    <SlotsIcon slot={slot} Image={image}/>
  );
});
